import { Controller } from "@hotwired/stimulus"

// Country code selector with flag emojis.
// Renders a dropdown of common country codes with flags.
// Updates the phone input prefix and stores the selected code.
export default class extends Controller {
  static targets = ["display", "dropdown", "codeInput", "phoneInput"]

  static COUNTRIES = [
    { code: "+1", flag: "🇺🇸", name: "United States", short: "US" },
    { code: "+1", flag: "🇨🇦", name: "Canada", short: "CA" },
    { code: "+44", flag: "🇬🇧", name: "United Kingdom", short: "GB" },
    { code: "+61", flag: "🇦🇺", name: "Australia", short: "AU" },
    { code: "+91", flag: "🇮🇳", name: "India", short: "IN" },
    { code: "+52", flag: "🇲🇽", name: "Mexico", short: "MX" },
    { code: "+55", flag: "🇧🇷", name: "Brazil", short: "BR" },
    { code: "+49", flag: "🇩🇪", name: "Germany", short: "DE" },
    { code: "+33", flag: "🇫🇷", name: "France", short: "FR" },
    { code: "+39", flag: "🇮🇹", name: "Italy", short: "IT" },
    { code: "+34", flag: "🇪🇸", name: "Spain", short: "ES" },
    { code: "+81", flag: "🇯🇵", name: "Japan", short: "JP" },
    { code: "+82", flag: "🇰🇷", name: "South Korea", short: "KR" },
    { code: "+86", flag: "🇨🇳", name: "China", short: "CN" },
    { code: "+971", flag: "🇦🇪", name: "UAE", short: "AE" },
    { code: "+966", flag: "🇸🇦", name: "Saudi Arabia", short: "SA" },
    { code: "+234", flag: "🇳🇬", name: "Nigeria", short: "NG" },
    { code: "+27", flag: "🇿🇦", name: "South Africa", short: "ZA" },
    { code: "+63", flag: "🇵🇭", name: "Philippines", short: "PH" },
    { code: "+972", flag: "🇮🇱", name: "Israel", short: "IL" }
  ]

  connect() {
    this.isOpen = false
    this.selectedCode = "+1"
    this.selectedFlag = "🇺🇸"

    // Close on outside click
    this._closeOnOutsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    document.addEventListener("click", this._closeOnOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this._closeOnOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasDropdownTarget) this.buildDropdown()
    this.dropdownTarget.classList.add("open")
    this.isOpen = true
  }

  close() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.remove("open")
    }
    this.isOpen = false
  }

  select(event) {
    const item = event.currentTarget
    const code = item.dataset.code
    const flag = item.dataset.flag

    this.selectedCode = code
    this.selectedFlag = flag

    if (this.hasDisplayTarget) {
      this.displayTarget.innerHTML = `<span class="gl-onboarding-flag">${flag}</span><span>${code}</span><i class="ph ph-caret-down" style="font-size: 10px; opacity: 0.5;"></i>`
    }

    if (this.hasCodeInputTarget) {
      this.codeInputTarget.value = code
    }

    this.close()
  }

  buildDropdown() {
    const dropdown = document.createElement("div")
    dropdown.className = "gl-country-dropdown"
    dropdown.setAttribute("data-country-code-target", "dropdown")

    const list = this.constructor.COUNTRIES.map(c => `
      <button type="button" class="gl-country-option" data-code="${c.code}" data-flag="${c.flag}" data-action="click->country-code#select">
        <span class="gl-country-option-flag">${c.flag}</span>
        <span class="gl-country-option-name">${c.name}</span>
        <span class="gl-country-option-code">${c.code}</span>
      </button>
    `).join("")

    dropdown.innerHTML = list
    this.element.appendChild(dropdown)
  }
}
